import CrucibleMetadata from './crucibleScene/crucibleMetadata';
import CrucibleScene from './crucibleScene/crucibleScene';
import { webglSupport } from 'utils/checkWebgl';

class CrucibleSceneStore {
  public activeScene: CrucibleScene | null;
  public activeSceneId: string;
  public metadata: CrucibleMetadata | null;

  constructor() {
    this.activeSceneId = '';
    this.activeScene = webglSupport() ? new CrucibleScene() : null;
    this.metadata = null;
  }

  reloadScene(options: { textureQuality: string }) {
    if (this.activeScene === null) return;
    this.activeScene.changeTextureQuality(options.textureQuality);

    if (
      this.activeSceneId !== '' &&
      this.metadata !== null &&
      this.metadata.crucibleId === this.activeSceneId
    ) {
      this.activeScene.stopRendering();
      this.activeScene.clear();
      this.activeScene.isLoaded = false;
      this.activeScene.crucible.isUpdated = false;
      this.activeScene.loadCrucible(this.metadata);
      this.activeScene.startRendering();
    }
  }

  loadScene(
    metadata: CrucibleMetadata,
    options: {
      idTextVisible: boolean;
      screenshotMode: boolean;
    }
  ) {
    if (this.activeScene === null) return;
    this.activeScene.options.idTextVisible = options.idTextVisible;
    this.activeScene.options.screenshotMode = options.screenshotMode;
    if (options.screenshotMode)
      this.activeScene.options.textureQuality = 'screenshot';

    if (metadata.crucibleId === this.activeSceneId) {
      return;
    } else {
      if (this.activeSceneId !== '') {
        this.activeScene.stopRendering();
        this.activeScene.clear();
      }
      this.activeSceneId = metadata.crucibleId;
      this.activeScene.isLoaded = false;
      this.activeScene.crucible.isUpdated = false;
      this.activeScene.loadCrucible(metadata);
      this.metadata = metadata;
    }
  }
}

export default new CrucibleSceneStore();
